/**
 * @generated SignedSource<<2a0f8e0cff34e7ec7aa105e7bd838126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoAssigneesPopover_Roles$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoleListItem_role">;
  readonly " $fragmentType": "TodoAssigneesPopover_Roles";
}>;
export type TodoAssigneesPopover_Roles$key = ReadonlyArray<{
  readonly " $data"?: TodoAssigneesPopover_Roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoAssigneesPopover_Roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoAssigneesPopover_Roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleListItem_role"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "237c7a983e91d4d1fd8ea270f585ce33";

export default node;
